import React, { useEffect } from "react";
import {
  PickedUp,
  AtOrigin,
  InTransit,
  AtDestination,
  Delivered,
  ArrowRightB,
} from "../../assets/Icons";
import "./OrderTracker.scss";

const TrackingItems = [
  { status: "Picked up from shipper", img: PickedUp, id: "pickedup" },
  { status: "At origin destination", img: AtOrigin, id: "origin" },
  { status: "Shipped (in transit)", img: InTransit, id: "transit" },
  {
    status: "Arrived at destination airport",
    img: AtDestination,
    id: "destination",
  },
  { status: "Delivered to consignee", img: Delivered, id: "delivered" },
];

function OrderTracker({ order, ...props }) {
  const [activeItem, setActiveItem] = React.useState("");

  useEffect(() => {
    if (order !== undefined) {
      setActiveItem(order.status);
    }
  }, [order]);

  return (
    <div
      className={
        props.details
          ? "TrackerStatusContainer"
          : "TrackerStatusContainer ContainerPreview"
      }
    >
      {order !== undefined
        ? TrackingItems.map((item, i) => {
            return (
              <div
                className={
                  activeItem === item.id
                    ? props.details
                      ? "TrackerStatus ActiveStatus"
                      : "TrackerStatus ActiveStatus StatusPreview"
                    : props.details
                    ? "TrackerStatus"
                    : "TrackerStatus StatusPreview"
                }
                key={item.status}
              >
                <div className="TrackerImageContainer">
                  <img
                    src={item.img}
                    alt="tracking-status"
                    className={
                      activeItem === item.id
                        ? "FullOpacity MarginHorizontal TrackerImage ActiveImageStatus"
                        : "ReducedOpacity MarginHorizontal TrackerImage"
                    }
                  />
                </div>
                <div
                  className={
                    props.details
                      ? "TrackerArrowContainer"
                      : "TrackerArrowContainerPreview"
                  }
                >
                  <img
                    className={i === 0 ? "TrackerArrow Hidden" : "TrackerArrow"}
                    src={ArrowRightB}
                    alt="right-arrow"
                  />
                </div>
                <div
                  className={
                    props.details
                      ? "StatusTextContainer"
                      : "StatusTextContainer Hide"
                  }
                >
                  <p className="StatusText">{item.status}</p>
                  {order.atr !== undefined && order.atr[item.id] ? (
                    <p
                      className="Italic EstimateText"
                      style={{ marginBottom: 0, marginTop: "20px" }}
                    >
                      Actual ready date: <br />
                      {order.atr[item.id]}
                    </p>
                  ) : (
                    <p
                      className="Italic EstimateText"
                      style={{ marginBottom: 0, marginTop: "20px" }}
                    >
                      Estimated ready date: <br />
                      {order.etr[item.id]}
                    </p>
                  )}
                </div>
              </div>
            );
          })
        : "Nincs megjelenítendő adat"}
    </div>
  );
}

export default OrderTracker;
